import {AppStatusDto} from "../model/AppStatusDto";
import {AppStatus} from "../model/AppStatus";

export const parseAppStatus = (data: AppStatusDto): AppStatus => ({
    shepherdStatus: data.shepherd_status,
    watchdogStatus: data.watchdog_status,
    backendApiStatus: data.backend_api_status,
    backupUrl: data.backup_url
})
